// RegEx para nombres con acentos (á, é, í, ó, ú, ñ, Á, É, Í, Ó, Ú, Ñ) y espacios. Permite cero o más caracteres
const NAMES_REGEX = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ ]*$/;
const NO_LOWER_CASE_REGEX = /[^a-z0-9\s*]/g;

export { NAMES_REGEX, NO_LOWER_CASE_REGEX };
